import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

export function Notifications() {
    const { notifications, removeNotification } = useNotifications();

    return (
        <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 2000 }}>
            {notifications.map((notification) => (
                <Snackbar
                    key={notification.id}
                    open={true}
                    autoHideDuration={6000}
                    onClose={() => removeNotification(notification.id)}
                >
                    <Alert 
                        onClose={() => removeNotification(notification.id)}
                        severity={notification.type || 'info'}
                    >
                        {notification.message}
                    </Alert>
                </Snackbar>
            ))}
        </div>
    );
} 